import { useMutation, useQuery, useQueryClient, keepPreviousData } from '@tanstack/react-query'
import { getDashboardStatus } from '../api/dashboard'
import { confirmIncident } from '../api/sessions'
import type { DashboardStatus } from '../types'

export const DASHBOARD_KEY = ['dashboardStatus'] as const

export function useDashboard() {
  return useQuery<DashboardStatus>({
    queryKey: DASHBOARD_KEY,
    queryFn: getDashboardStatus,
    // Fetched once per page open — active incident is polled separately via useActiveIncident
    placeholderData: keepPreviousData,
  })
}

export function useConfirmIncident() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: confirmIncident,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: DASHBOARD_KEY })
      queryClient.invalidateQueries({ queryKey: ['activeIncident'] })
    },
  })
}
